import { render } from "./legoDropdownSearch.vue?vue&type=template&id=6ae621d1&scoped=true"
import script from "./legoDropdownSearch.vue?vue&type=script&lang=js"
export * from "./legoDropdownSearch.vue?vue&type=script&lang=js"

import "./legoDropdownSearch.vue?vue&type=style&index=0&id=6ae621d1&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ae621d1"],['__file',"src/components/lego/extend/legoDropdownSearch.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6ae621d1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6ae621d1', __exports__)) {
    api.reload('6ae621d1', __exports__)
  }
  
  module.hot.accept("./legoDropdownSearch.vue?vue&type=template&id=6ae621d1&scoped=true", () => {
    api.rerender('6ae621d1', render)
  })

}


export default __exports__